import '@mdi/font/css/materialdesignicons.css';
import 'v-calendar/style.css';
import { createApp, defineAsyncComponent } from 'vue';
import VueMobileDetection from 'vue-mobile-detection';
import VueTheMask from 'vue-the-mask';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';

import { aliases, fa } from 'vuetify/iconsets/fa';
import { mdi } from 'vuetify/iconsets/mdi';

import { DatePicker } from 'v-calendar';
import Certificates from './vueComponents/admin/certificates.vue';
import DashboardAnnouncement from './vueComponents/admin/dashboardAnnouncement.vue';
import ElearningCourses from './vueComponents/admin/elearningCourses.vue';
import ElearningExtendedCourses from './vueComponents/admin/elearningExtendedCourses.vue';
import ExternalLmsClientKeys from './vueComponents/admin/externalLmsClientKeys.vue';
import ExternalLmsRegistrations from './vueComponents/admin/externalLmsRegistrations.vue';
import PfsAnalytics from './vueComponents/admin/analytics/analytics-dashboard.vue';
import ProductPackages from './vueComponents/admin/productPackages.vue';
import Products from './vueComponents/admin/products.vue';
import Supply from './vueComponents/admin/supply.vue';
import UserSupply from './vueComponents/admin/userSupply.vue';

import { appPlugins } from './app-plugins';

const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VTextField: { variant: 'solo' },
    VSelect: { variant: 'solo' },
    VAutocomplete: { variant: 'solo' },
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
      mdi,
    },
  },
});
const app = createApp({});
app.use(vuetify);
app.use(VueTheMask);

app.use(VueMobileDetection);

// This bundle is loaded only by legacy web/admin/*.php pages (see resources/js/public-site.js
// for the components used by the public-facing site, which used to share this same bundle).
app.component('user-supply', UserSupply);
app.component('supply', Supply);
app.component('product-packages', ProductPackages);
app.component('certificates', Certificates);
app.component('products', Products);
app.component('elearning-courses', ElearningCourses);
app.component('elearning-extended-courses', ElearningExtendedCourses);
app.component('external-lms-client-keys', ExternalLmsClientKeys);
app.component('external-lms-registrations', ExternalLmsRegistrations);
app.component('pfs-analytics', PfsAnalytics);
app.component('item-bank-admin', defineAsyncComponent(() => import('./vueComponents/admin/itemBank.vue')));
app.component('dashboard-announcement', DashboardAnnouncement);

app.use(appPlugins.pinia);
app.component('vue-date-picker', DatePicker);
app.mount('#main');
